/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelAssignment } from '../../models/travel-assignment';

export interface TravelControllerRejectAssignment$Params {
  id: number;
  identifier: string;
}

export function travelControllerRejectAssignment(http: HttpClient, rootUrl: string, params: TravelControllerRejectAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerRejectAssignment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('identifier', params.identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelAssignment;
      }>;
    })
  );
}

travelControllerRejectAssignment.PATH = '/travel/draft/{id}/assign-request/{identifier}/reject';
